import { AfterViewInit, Directive, ElementRef } from '@angular/core';
import { NbAccordionComponent, NbAccordionItemComponent } from '@nebular/theme';

@Directive({
  selector: '[kwExpandFirstItem]'
})
export class ExpandFirstItemDirective implements AfterViewInit {

  constructor(private el:ElementRef) { }
  
  ngAfterViewInit(): void {
    const host = <HTMLElement>this.el.nativeElement;
    const firstItem = <Element>host.firstElementChild;
    const itemClasses = ["expanded","collapsed"];
    itemClasses.forEach(toggleClass => {
      firstItem.classList.toggle(toggleClass);
    })
    const headerItem = <Element>firstItem.firstElementChild;
    const headerClasses = ["accordion-item-header-expanded","accordion-item-header-collapsed"];
    headerClasses.forEach(toggleClass => {
      headerItem.classList.toggle(toggleClass);
    })
  }


}
